<div>
  <div class="flex flex-col gap-5 md:flex-row md:items-end">
    <div>
      <h1 class="text-2xl font-semibold dark:text-white-light md:text-3xl">{{ 'merchant_products' | translate }}</h1>
    </div>
  </div>

  <div class="mt-5 grid grid-cols-1 gap-4 md:grid-cols-12">
    <div class="md:col-span-4">
      <app-debounce-input
        (valueChange)="onInputChanged($event)"
        [delay]="600"
        class="w-full"
      ></app-debounce-input>
    </div>

    <div class="md:col-span-4">
      <ng-select
        [items]="merchants"
        bindLabel="label"
        bindValue="value"
        [clearable]="true"
        placeholder="Select Merchant"
        class="custom-multiselect w-full"
        [(ngModel)]="params.merchantCode"
        (change)="onMerchantChange($event)"
      >
      </ng-select>
    </div>

    <div class="md:col-span-4">
      <ng-select
        [items]="providers"
        bindLabel="label"
        bindValue="value"
        [clearable]="true"
        placeholder="Select Provider"
        class="custom-multiselect w-full"
        [(ngModel)]="params.providerId"
        (change)="onProviderChange($event)"
      >
      </ng-select>
    </div>

    <div class="md:col-span-4">
      <ng-select
        [items]="categories"
        bindLabel="label"
        bindValue="value"
        [clearable]="true"
        placeholder="Select Category"
        class="custom-multiselect w-full"
        [(ngModel)]="params.categoryId"
        (change)="onCategoryChange($event)"
      >
      </ng-select>
    </div>

    <div class="md:col-span-4">
      <ng-select
        [items]="products"
        bindLabel="label"
        bindValue="value"
        [clearable]="true"
        placeholder="Select Product"
        class="custom-multiselect w-full"
        [(ngModel)]="params.productCode"
        (change)="onProductChange($event)"
      >
      </ng-select>
    </div>

    <!-- <div class="md:col-span-4">
      <ng-select
        [items]="roles"
        [clearable]="true"
        placeholder="Select Role"
        class="custom-multiselect w-full"
        [(ngModel)]="params.roleId"
        (change)="onRoleChange($event)"
      >
      </ng-select>
    </div> -->

    <div class="md:col-span-4">
      <button type="button" class="btn btn-primary w-full" (click)="goToForm('new')">
        <icon-plus class="mr-2"></icon-plus>
        New
      </button>
    </div>
  </div>

  <div class="panel mt-4 pb-0">
    <div class="datatable">
      <ng-datatable
        [isServerMode]="true"
        [rows]="rows"
        [columns]="cols"
        [loading]="loading"
        [totalRows]="totalRows"
        [pageSize]="params.rowPerPage"
        [search]="params.filter"
        [pageSizeOptions]="pageSizeOptions"
        (changeServer)="changeServer($event)"
        skin="whitespace-nowrap table-hover"
        firstArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M13 19L7 12L13 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path opacity="0.5" d="M16.9998 19L10.9998 12L16.9998 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
        lastArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M11 19L17 12L11 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path opacity="0.5" d="M6.99976 19L12.9998 12L6.99976 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg> '
        previousArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M15 5L9 12L15 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
        nextArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
      >
        <ng-template slot="action" let-value="data">
          <div class="flex items-center justify-end">
            <div>
              <button
                ngxTippy="Edit"
                type="button"
                class="stroke-green-700"
                (click)="goToForm(value.id)"
              >
                <icon-pencil class="mr-2 text-success"></icon-pencil>
              </button>
            </div>
            <div>
              <button
                ngxTippy="Delete"
                type="button"
                (click)="selectedId = value.id; modal.open()"
              >
                <icon-trash class="text-danger"></icon-trash>
              </button>
            </div>
          </div>
        </ng-template>
      </ng-datatable>

      <modal #modal>
        <ng-template #modalHeader>
          <h4 class="p-5 pb-0 text-lg font-bold">{{ modalData.header }}</h4>
        </ng-template>
        <ng-template #modalBody>
          <p>{{ modalData.body }}</p>
        </ng-template>
        <ng-template #modalFooter>
          <div class="flex flex-row items-center gap-2">
            <button
              type="button"
              (click)="modal.close()"
              [class]="'btn btn-outline-info ' + modalData.closeButtonClass"
            >
              {{ modalData.closeButtonLabel }}
            </button>
            <button
              type="button"
              (click)="onModalDeleteConfirm(selectedId)"
              [class]="'btn btn-danger ' + modalData.confirmButtonClass"
            >
              {{ modalData.confirmButtonLabel }}
            </button>
          </div>
        </ng-template>
      </modal>
    </div>
  </div>
</div>
